import { useState } from "react";
import { useTranslate } from "ra-core";

import {
  renderMessageTemplate,
  type MessagePlaceholderValues,
} from "./activityLogRules";

/**
 * Almikia Epic EA (TASK-111), DATA CONTRACT EA (6): renders an activity's or
 * a result's message template with its placeholders filled, plus a "Copiar
 * mensaje" button copying exactly the rendered text -- never the stored
 * template. Renders nothing when there is no template, per the ticket's own
 * acceptance criterion. Same copy/feedback pattern as
 * `ContactPersonalInfo.tsx`'s `EmailRow` (no new dependency for the
 * clipboard write).
 */
export function MessageBlock({
  template,
  values,
}: {
  template?: string | null;
  values: MessagePlaceholderValues;
}) {
  const translate = useTranslate();
  const [copied, setCopied] = useState(false);

  if (!template) return null;

  const rendered = renderMessageTemplate(template, values);

  const handleCopy = () => {
    navigator.clipboard.writeText(rendered).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="rounded-md border border-input bg-muted/30 p-3 flex flex-col gap-2">
      <p className="text-[15px] whitespace-pre-line">{rendered}</p>
      <button
        type="button"
        onClick={handleCopy}
        className="min-h-11 self-start px-1 text-sm font-medium text-primary underline"
      >
        {copied
          ? translate("crm.common.copied", { _: "¡Copiado!" })
          : translate("resources.deals.activity_log.message.copy", {
              _: "Copiar mensaje",
            })}
      </button>
    </div>
  );
}
